export default __webpack_public_path__ + "static/media/NovelHut.f050a50f.png";